// extracted by mini-css-extract-plugin
export var infoRow = "_tu-2";
export var labelContainer = "_tu-0";
export var rightInfo = "_tu-1";